import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { PROPERTY_VALUES, TIMELINES } from "@/lib/constants";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

const empty = { name: "", email: "", phone: "", property_value: "", property_type: "", timeline: "", message: "" };

export const ContactDialog = ({ open, onOpenChange, qi }) => {
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/qis/${qi.slug}/contact`, f);
      setSent(true);
      setF(empty);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) setSent(false); }}>
      <DialogContent className="bg-ink-2 border-white/10 rounded-[28px] max-w-lg text-white" data-testid="contact-dialog">
        <DialogHeader>
          <span className="eyebrow">Investor inquiry</span>
          <DialogTitle className="font-display text-2xl font-black">Contact {qi.company_name}</DialogTitle>
          <DialogDescription className="text-white/50">Your message goes straight to this intermediary's inbox.</DialogDescription>
        </DialogHeader>
        {sent ? (
          <div className="py-8 text-center" data-testid="contact-success">
            <CheckCircle2 className="mx-auto text-qi-emerald" size={44} />
            <p className="font-display text-xl font-bold mt-4">Message sent</p>
            <p className="text-sm text-white/50 mt-1">The QI will reply to you directly by email or phone.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="grid grid-cols-2 gap-3 mt-2">
            <input required placeholder="Your name" className="field col-span-2 sm:col-span-1" value={f.name} onChange={set("name")} data-testid="contact-name-input" />
            <input required type="email" placeholder="Email" className="field col-span-2 sm:col-span-1" value={f.email} onChange={set("email")} data-testid="contact-email-input" />
            <input placeholder="Phone (optional)" className="field col-span-2 sm:col-span-1" value={f.phone} onChange={set("phone")} data-testid="contact-phone-input" />
            <select className="field col-span-2 sm:col-span-1" value={f.property_value} onChange={set("property_value")} data-testid="contact-value-select">
              <option value="">Property value</option>
              {PROPERTY_VALUES.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
            <select className="field col-span-2" value={f.timeline} onChange={set("timeline")} data-testid="contact-timeline-select">
              <option value="">Where are you in the exchange?</option>
              {TIMELINES.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
            <textarea required rows={4} placeholder="Tell them about your relinquished property and goals..." className="field col-span-2 resize-none" value={f.message} onChange={set("message")} data-testid="contact-message-input" />
            <button disabled={busy} className="btn-pink col-span-2 mt-1" data-testid="contact-submit-button">{busy ? "Sending..." : "Send inquiry"}</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
